<script lang="ts">
    import {
        current_edit_function,
        execute_function,
        type EditFunctionName,
        clear_function_context,
    } from "$lib/commands/edit";
    import { onMount } from "svelte";
    import { file } from "$lib/state";
    import type { ToolOption, ToolOptions } from "$lib/wasm/interaction";
    import Options from "$lib/utility/Options.svelte";


    let name = null as null | EditFunctionName;
    let blockingDataChanged = 0;

    let dataChangeSubscription: { unsubscribe: () => void } | null = null;
    onMount(() => {
        let unsub = file.subscribe((file) => {
            close();
            if (!file) return;

            dataChangeSubscription?.unsubscribe();
            dataChangeSubscription = file!.onDataChanged.subscribe(() => {
                if (blockingDataChanged) return blockingDataChanged -= 1;
                close();
            });
        });

        return () => {
            dataChangeSubscription?.unsubscribe();
            unsub();
        };
    });

    let options = new Map<string, ToolOption>() as ToolOptions;

    onMount(() => current_edit_function.subscribe((current) => {
        if (!current) return name = null;
        name = current.name;

        update_options(current.options);
        blockDataChanged();
    }));

    function update_options(newOptions: ToolOptions) {
        if (!newOptions) return;
        if (newOptions.size === 0) return;

        options = newOptions;
    }

    function update(option: string) {
        if (!name) return;

        let newValue = options!.get(option)!.value;
        if (newValue === undefined) return;

        execute_function(name, true);
        blockDataChanged();
    }

    function close() {
        clear_function_context();
    }

    function blockDataChanged() {
        blockingDataChanged += 1;
    }

</script>

<!----------------------------------------------------------------------------->

{#if name !== null && options.size > 0}
    <div class="function-options">
        <h3>{name?.replaceAll("-", " ").capitalize()}</h3>

        <Options {options} {update} />

        <button class="close" on:click={close} />
    </div>
{/if}

<!----------------------------------------------------------------------------->

<style>
    .function-options {
        position: absolute;
        left: 0.25em;
        bottom: 0.25em;

        background: var(--g100);
        padding: 0.5em;
    }

    h3 {
        all: unset;
        display: block;
        color: var(--t400);
        margin-bottom: 0.5rem;
    }

    .close {
        all: unset;
        position: absolute;
        top: 0;
        right: 0;
        width: 1em;
        height: 1em;
        background: red;
    }
</style>
